import { createIcon } from "@chakra-ui/react";

export const PopOut = createIcon({
  displayName: "PopOut",
  viewBox: "0 0 24 24",
  d: "M14.998 4a1.004 1.004 0 0 0-.71 1.71L15.583 7l-5.29 5.292a1.001 1.001 0 0 0 1.416 1.415l5.29-5.292 1.293 1.293a.995.995 0 0 0 1.09.216A1 1 0 0 0 20 8.999v-4C20 4.448 19.553 4 19 4h-4.002zM6.5 5A2.499 2.499 0 0 0 4 7.5v9.997c0 1.381 1.119 2.5 2.5 2.5h9.998c1.38 0 2.5-1.119 2.5-2.5v-3.499a.999.999 0 1 0-2 0v3.5c0 .274-.226.5-.5.5H6.5a.501.501 0 0 1-.5-.5V7.498c0-.275.225-.5.5-.5h3.499a.999.999 0 1 0 0-2h-3.5z",
  defaultProps: {
    "aria-label": "An arrow emerging out of a square"
  }
});

export default PopOut;
